/* eslint-disable max-len */
import React from 'react';

const AlignLeftIcon = props => (
  <svg width={19} height={19} viewBox="0 0 19 19" {...props}>
    <path
      fillRule="evenodd"
      d="M4.2 5h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0 6h10.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0-3h6.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2zm0 6h4.6c.11 0 .2.09.2.2v.6a.2.2 0 0 1-.2.2H4.2a.2.2 0 0 1-.2-.2v-.6c0-.11.09-.2.2-.2z"
    />
  </svg>
);

export default AlignLeftIcon;
